import { createFileRoute } from '@tanstack/react-router'

import Privacy from '@/features/Auth/Privacy'
import { RouteErrorComponent } from '@/shared/RouteErrorComponent/RouteErrorComponent.tsx'

export const Route = createFileRoute('/_public/privacy')({
    component: RouteComponent,
    onError: RouteErrorComponent,
})

function RouteComponent() {
    return <Privacy />
}
